(() => {
  if (window.menuMarcasInit) return;
  window.menuMarcasInit = true;

  const OPEN_CLASS = 'is-open';
  const CLOSE_DELAY = 350;
  // Mientras está abierto, panel y overlay viven en <body> para quedar por encima del header.
  const opened = new Map();

  const portal = (el) => {
    const slot = {parent: el.parentNode, next: el.nextSibling};
    document.body.appendChild(el);
    return slot;
  };

  const restore = (el, slot) => {
    if (slot.next && slot.next.parentNode === slot.parent) slot.parent.insertBefore(el, slot.next);
    else slot.parent.appendChild(el);
  };

  const open = (layout) => {
    if (opened.has(layout)) return;
    const aside = layout.querySelector('.menu-marcas');
    const overlay = layout.querySelector('.menu-marcas__overlay');
    const toggle = layout.querySelector('[data-menu-marcas-open]');
    if (!aside || !overlay) return;

    const state = {aside, overlay, layout, toggle, slots: [portal(overlay), portal(aside)]};
    opened.set(layout, state);
    toggle?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('menu-marcas-lock');

    void aside.offsetWidth; // fuerza reflow para que corra la transición
    aside.classList.add(OPEN_CLASS);
    overlay.classList.add(OPEN_CLASS);
  };

  const close = (layout) => {
    const state = opened.get(layout);
    if (!state) return;
    const {aside, overlay, toggle, slots} = state;

    opened.delete(layout);
    aside.classList.remove(OPEN_CLASS);
    overlay.classList.remove(OPEN_CLASS);
    toggle?.setAttribute('aria-expanded', 'false');
    if (!opened.size) document.documentElement.classList.remove('menu-marcas-lock');

    setTimeout(() => {
      restore(aside, slots[1]);
      restore(overlay, slots[0]);
    }, CLOSE_DELAY);
  };

  const findState = (target) => {
    for (const state of opened.values()) {
      if (state.aside.contains(target) || state.overlay.contains(target)) return state;
    }
    return null;
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-menu-marcas-open]');
    if (opener) {
      const layout = opener.closest('.menu-marcas-layout');
      if (layout) open(layout);
      return;
    }

    // Enlace con hijos: abre/cierra el submenú (igual que el botón +/-) en vez de navegar.
    const navLink = event.target.closest('.menu-marcas [data-nav-link-mobile]');
    const navTrigger = navLink?.nextElementSibling;
    if (navTrigger?.matches('[data-collapsible-trigger]')) {
      event.preventDefault();
      navTrigger.click();
      return;
    }

    const state = findState(event.target);
    if (!state) return;

    if (event.target.closest('[data-menu-marcas-close]') || event.target.closest('a[href]')) {
      close(state.layout);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    [...opened.keys()].forEach(close);
  });

  // Si se pasa a escritorio con el panel abierto, cerrarlo.
  window.matchMedia('(min-width: 768px)').addEventListener('change', (event) => {
    if (event.matches) [...opened.keys()].forEach(close);
  });
})();
